export default {
  ADMIN: "COMPANY_ADMIN",
  EMPLOYEE: "EMPLOYEE",
};
